module.exports = __webpack_public_path__ + "static/img/robot.651cd5c7.png";